// extracted by mini-css-extract-plugin
export default {"indicatorContainer":"XVYtU","flexbox":"-Kj9P","privateIndicator":"ozUqv","toTheRight":"_32Iwv","toTheBottom":"_76ZUi"};